@let apiResponse = jobData();
@if (apiResponse) {
  <p-table
    [value]="apiResponse.data"
    [showGridlines]="true"
    [scrollable]="true"
    scrollHeight="flex"
    stripedRows
    [loading]="
      batchService.batchJobDatasource.isLoading() &&
      !batchService.batchJobDatasource.isLoaded()
    "
    [(first)]="batchService.batchJobFirstRecord"
    class="p-datatable-sm lp-table"
    selectionMode="single"
    [metaKeySelection]="true"
    (onRowSelect)="onRowSelect()"
    [(selection)]="batchService.selectedBatchJob"
    dataKey="id"
    [lazy]="true"
    [lazyLoadOnInit]="false"
    (onLazyLoad)="onLazyLoad($event)"
    sortField="start"
    [sortOrder]="-1"
    [rows]="100"
    [paginator]="true"
    [totalRecords]="apiResponse.totalRowCount"
    [showJumpToPageDropdown]="true"
    letKeepScrollPosition>
    <ng-template pTemplate="header">
      <tr>
        <th>Jobnavn</th>
        <th>Startet</th>
        <th>Afsluttet</th>
        <th>Status</th>
      </tr>
    </ng-template>
    <ng-template [appTableRow]="apiResponse.data" pTemplate="body" let-item>
      <tr
        [pSelectableRow]="item"
        class="cursor-pointer"
        [class]="rowClass(item)">
        <td>
          {{ item.batchJobSchedule.jobNavn }}
        </td>
        <td class="numbers">
          {{ item.start | date: 'dd-MM-yyyy HH:mm:ss' }}
        </td>
        <td class="numbers">
          {{ item.slut | date: 'dd-MM-yyyy HH:mm:ss' }}
        </td>
        <td>
          <span style="display: inline-block; width: 80px">{{
            item.status
          }}</span>

          @if (item.antalFejl > 0) {
            <span class="ml-2 text-error font-bold">
              <i class="pi pi-times-circle"></i>
              {{ item.antalFejl }}
            </span>
          }
          @if (item.antalAdvarsler > 0) {
            <span class="ml-2 text-warning font-bold">
              <i class="pi pi-exclamation-triangle"></i>
              {{ item.antalAdvarsler }}
            </span>
          }
        </td>
      </tr>
    </ng-template>
  </p-table>
}
<p-dialog
  [header]="batchService.selectedBatchJob()?.batchJobSchedule?.jobNavn"
  [modal]="true"
  (onHide)="onHideJobDetails()"
  [(visible)]="showDetails"
  appendTo="body"
  [style]="{
    width: '80%',
    maxHeight: '90%',
    maxWidth: '1400px',
    height: '80%',
  }">
  @let job = batchService.selectedBatchJob();
  @if (job) {
    <app-batch-job-detail
      [batchJob]="job"
      (closeWindowRequest)="showDetails.set(false)" />
  }
</p-dialog>
